<template>
  <div>
    <b-row class="pb-3">
      <b-col lg="4">
        <h2>Documents</h2>
      </b-col>
      <b-col lg="4">
        <div class="">
          <b-form inline>
            <label class="mr-sm-2" for="inline-form-custom-select-pref"
              >Type</label
            >
            <v-select
              class="vue-select w-75"
              placeholder="All"
              :options="docTypeOptions"
              v-model="claim_type_id"
              :reduce="(option) => option.id"
            ></v-select>
          </b-form>
        </div>
      </b-col>
      <b-col lg="4">
        <div class="">
          <b-input-group>
            <b-form-input
              class="search-outline"
              placeholder="Search Document"
              v-model="globalFilterStr"
            ></b-form-input>
            <b-input-group-append>
              <b-button
                @click="clearGlobalDocSearchString"
                variant="outline-secondary"
                ><i class="fa-solid fa-times"></i
              ></b-button>
              <b-button
                @click="startGlobalDocSearchString"
                variant="outline-secondary"
                ><i class="fa-solid fa-magnifying-glass"></i
              ></b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <b-card>
          <b-row align-v="center" slot="header">
            <b-col cols="8">
              <h3 class="mb-0">Client Claim Evidence</h3>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <vuetable
                ref="vuetable"
                :api-mode="false"
                :fields="fields"
                :sort-order="sortOrder"
                :per-page="perPage"
                :data-manager="dataManager"
                pagination-path="pagination"
                @vuetable:pagination-data="onPaginationData"
              >
                <template slot="fileType" scope="props">
                  <span
                    v-html="getFileExtImg(props.rowData.fileExtention)"
                    class="pr-2"
                  ></span>
                  <span
                    v-html="truncateText(multiFileUploadString(props.rowData))"
                  ></span>
                  <a
                    v-if="multiFileUploadString(props.rowData).length > 60"
                    class="a-style"
                    @click="
                      setActiveFileStr(multiFileUploadString(props.rowData))
                    "
                    v-b-modal.modal-file-str-upload-doc
                  >
                    View More</a
                  >
                </template>
                <template slot="sourceType" scope="props">
                  <span>{{ user_name }}</span>
                </template>
              </vuetable>
            </b-col>
            <b-col cols="12">
              <div style="padding-top: 10px">
                <vuetable-pagination-info
                  ref="paginationInfo"
                ></vuetable-pagination-info>
                <vuetable-pagination
                  class="float-right"
                  ref="pagination"
                  @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <!-- Start File Str Modal -->
    <b-modal id="modal-file-str-upload-doc" hide-footer>
      <template #modal-title>
        <h3>Detail View</h3>
      </template>
      <div class="d-block">
        <b-row>
          <b-col cols="12">
            <p v-html="activeFileStr"></p>
          </b-col>
        </b-row>
      </div>

      <div class="float-right mt-5">
        <b-button variant="" @click="$bvModal.hide('modal-file-str-upload-doc')"
          >Cancel</b-button
        >
      </div>
    </b-modal>
    <!-- End File Str Modal -->
  </div>
</template>

<script>
import Vuetable from "vuetable-2/src/components/Vuetable";
import DocumentDef from "./DocumentDef.js";
import "vue-select/dist/vue-select.css";
import VuetablePagination from "../Vuetable/VuetablePaginationBootstrap4";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo.vue";
import { mapActions, mapState } from "vuex";
import mixins from "../../mixins/common.js";

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
  },
  data() {
    return {
      fields: DocumentDef,
      perPage: 10,
      sortOrder: [],
      documentData: [],
      docTypeOptions: [],
      claim_type_id: "",
      globalFilterStr: "",
      activeFileStr: "",
    };
  },
  props: ["claim_id"],
  watch: {
    claim_id: function (newVal, oldVal) {
      this.refreshClaimDocs();
    },
    claim_type_id: function (newVal, oldVal) {
      this.$refs.vuetable.refresh();
    },
    // globalFilterStr: function (newVal, oldVal) {
    //   this.$refs.vuetable.refresh();
    // },
    documentData(newVal, oldVal) {
      this.$refs.vuetable.refresh();
    },
  },
  mixins: [mixins],
  methods: {
    ...mapActions("client", ["getUserClaims", "getClaimDocuments"]),
    setActiveFileStr(activeFileStr) {
      this.activeFileStr = activeFileStr;
    },
    refreshClaimDocs() {
      this.isLoading = true;
      const claimParams = {
        claim_id: this.claim_id,
      };
      if (this.claim_id) {
        this.getClaimDocuments(claimParams).then((data) => {
          if (data.data.errors) {
          } else {
            this.docTypeOptions = [
              {
                id: "",
                label: "All",
              },
            ];
            let filtered = data.data.filter((docData) => {
              let obj = {
                id: docData.documentType.id,
                label: docData.documentType.type,
              };
              this.docTypeOptions.push(obj);
              return docData.isUploaded;
            });

            if (filtered[0]) {
              this.documentData = filtered;
            } else {
              this.documentData = [];
            }
          }
          this.isLoading = false;
        });
      } else {
        this.documentData = [];
        this.isLoading = false;
      }
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    dataManager(sortOrder, pagination) {
      let local = this.documentData;

      // account for search filter
      if (this.claim_type_id) {
        let claim_type_str = this.claim_type_id;
        let dataFil = _.filter(local, function (item) {
          return item.documentType.id == claim_type_str;
        });
        local = dataFil;
      }

      if (this.globalFilterStr) {
        // the text should be case insensitive
        let txt = new RegExp(this.globalFilterStr, "i");
        let dataFil = _.filter(local, function (item) {
          return item.fileName && item.fileName.search(txt) >= 0;
        });
        local = dataFil;
      }

      // sortOrder can be empty, so we have to check for that as well
      if (sortOrder.length > 0) {
        local = _.orderBy(
          local,
          sortOrder[0].sortField,
          sortOrder[0].direction
        );
      }

      pagination = this.$refs.vuetable.makePagination(
        local.length,
        this.perPage
      );
      let from = pagination.from - 1;
      let to = from + this.perPage;
      return {
        pagination: pagination,
        data: _.slice(local, from, to),
      };
    },
    clearGlobalDocSearchString() {
      this.globalFilterStr = "";
      this.$refs.vuetable.refresh();
    },
    startGlobalDocSearchString() {
      this.$refs.vuetable.refresh();
    },
  },
  computed: {
    ...mapState("user", ["user_name"]),
  },
};
</script>

<style>
</style>
